import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import Layout from '@/layout'

const router = new VueRouter({
    routes: [
        {
            path: '/', //浏览器地址路径
            component: Layout, //注册路由组件
            redirect: 'login', //重定向

            //二级路由
            children: [
                {
                    path: 'addorder',
                    component: () => import('@/views/addOrder/index.vue'),
                },
                {
                    path: 'addorder/neworder',
                    component: () => import('@/views/addOrder/newOrder/index.vue'),
                },
                {
                    path: 'table',
                    component: () => import('@/views/table/index.vue'),
                    beforeEnter: (to, from, next) => {
                        if( localStorage.getItem('loginUser') === 'admin' ) {
                            next();
                        } else {
                            next(false);
                        }
                    }
                },
                {
                    path: 'qrCode',
                    component: () => import('@/views/tableQrCode/index.vue'),
                    beforeEnter: (to, from, next) => {
                        if( localStorage.getItem('loginUser') === 'admin' ) {
                            next();
                        } else {
                            next(false);
                        }
                    }
                },
                {
                    path: 'order',
                    component: () => import('@/views/order/index.vue'),
                },
                {
                    path: 'goods',
                    component: () => import('@/views/goods/index.vue'),
                    beforeEnter: (to, from, next) => {
                        if( localStorage.getItem('loginUser') === 'admin' ) {
                            next();
                        } else {
                            next(false);
                        }
                    }
                },
                {
                    path: 'category',
                    component: () => import('@/views/category/index.vue'),
                    beforeEnter: (to, from, next) => {
                        if( localStorage.getItem('loginUser') === 'admin' ) {
                            next();
                        } else {
                            next(false);
                        }
                    }
                },
                {
                    path: 'employee',
                    component: () => import('@/views/employee/index.vue'),
                    beforeEnter: (to, from, next) => {
                        if( localStorage.getItem('loginUser') === 'admin' ) {
                            next();
                        } else {
                            next(false);
                        }
                    }
                },
                {
                    path: 'user',
                    component: () => import('@/views/user/index.vue'),
                    beforeEnter: (to, from, next) => {
                        if( localStorage.getItem('loginUser') === 'admin' ) {
                            next();
                        } else {
                            next(false);
                        }
                    }
                },
                {
                    path: 'set',
                    component: () => import('@/views/set/index.vue'),
                    beforeEnter: (to, from, next) => {
                        if( localStorage.getItem('loginUser') === 'admin' ) {
                            next();
                        } else {
                            next(false);
                        }
                    }
                },
                {
                    path: 'dashboard',
                    component: () => import('@/views/statistics/index.vue')
                },
                {
                    path: 'acctbook',
                    component: () => import('@/views/acctBook/index.vue'),
                },
                {
                    path: 'printer',
                    component: () => import('@/views/printerTest/index.vue'),
                    
                    //独享守卫
                    beforeEnter: (to, from, next) => {
                        if( localStorage.getItem('loginUser') === 'admin' ) {
                            next();
                        } else {
                            next(false);
                        }
                    }
                },
                {
                    path: 'cheftask',
                    component: () => import('@/views/chefTask/index.vue'),
                    beforeEnter: (to, from, next) => {
                        if( localStorage.getItem('loginUser') === 'admin' || localStorage.getItem('loginUser') === '后厨' ) {
                            next();
                        } else {
                            next(false);
                        }
                    }
                },
            ]
        },
        {
            path: '/login',
            component: () => import('@/components/login/index.vue')
        },
        {
            path: '/receipt',
            component: () => import('@/views/printerTest/receipt/index.vue')
        },
        {
            path: '/tag',
            component: () => import('@/views/printerTest/tag/index.vue')
        },
        {
            path: '/menu',
            component: () => import('@/views/printerTest/menu/index.vue')
        },
    ]
})

//前置守卫
router.beforeEach((to, from, next) => {
    
    const token = localStorage.getItem('TOKEN');
    
    //去登录页
    if ( to.path === '/login' ) {

        if( token ) {
            next('/dashboard');
        } else {
            next();
        }

    } else {
        //访问其它页面
        if ( token ) {
            next();
        } else {
            next('/login');
        }
    }





})


export default router;


